<template>
  <div class="operation-summary">
      <p v-if="title" class="header-box">{{title}}</p>
      <div>
        <div v-if="summaryData && summaryData.length" class="summaryData-content">
          <div class="summaryData-item" v-for="(item, index) in summaryData" :key="index">
            <span class="subTitle">{{item.subTitle}}：</span>
            <span class="numbers">{{item.numbers || '--'}}</span>
          </div>
        </div>
        <div v-if="!summary.length && !loading">传入数据为空！</div>
        <div v-else class="content-box" :style="{ 'display': (divideEqually ? 'flex' : 'block')}">
          <div class="content-perIt"
          :style="
                {
                  'display': (divideEqually ? 'flex' : 'inline-block'),
                  'width' : item.width ? item.width : 'auto'
                }
              "
           v-for="(item, index) in summary" :key="item.numbers + index">
            <div class="content-item">
              <span class="sub-title">
                <el-tooltip v-if="item.toolTip" class="item" effect="dark" :content="item.toolTip" placement="top-start">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                {{item.subTitle}}：
                </span>
              <span class="need-show-text">
                <template v-if="item.hasOwnProperty('isThousandsSeparator') && item.isThousandsSeparator === false">
                  <span class="enlarge-content">{{item.numbers || '--'}}</span>
                </template>
                <template v-else>
                  <span class="enlarge-content" v-thousandsSeparator>{{item.numbers || '--'}}</span>
                </template>
                <span class="period" v-if="item.period">{{`元（共${item.period}期）`}}</span>
                <span v-else>{{item.unit || '元'}}</span>
              </span>
            </div>
            <div v-if="index !== (summary.length - 1)" class="verticalBar"></div>
          </div>
        </div>
      </div>
      <div>
      </div>
    </div>
</template>
<script>

// 传入数据基本格式

// <!-- 上下结构显示 -->
// summary: [{
//  subTitle: '**金额', // 副标题
//  numbers: 100, // 数字
//  isThousandsSeparator: true // 是否需要千分符，默认true
//  divideEqually: true // 是否平分显示收款金额
//  toolTip: '显示的气泡文字'
//  width: '140px' // 自定义宽度
// }]

// <!-- 左右结构显示 -->
// summaryData: [{
//  subTitle: '**金额', // 副标题
//  numbers: 100, // 数字
// }]
export default {
  name: 'OperationSummary',
  props: {
    title: {
      type: String,
      default: '',
    },
    summary: { // 上下结构显示
      type: Array,
      default: () => [],
    },
    summaryData: { // 左右结构
      type: Array,
      default: () => [],
    },
    divideEqually: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // summaryCopy: {}
    }
  },
  watch: {
    // summary: {
    //   handler (val) {
    //     this.summaryCopy = val
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  directives: {
    thousandsSeparator: {
      bind(el) {
        const modified = el.childNodes[0].data
        if (!isNaN(Number(modified))) {
          el.innerHTML = Number(modified).toLocaleString()
        }
      },
    },
  },
}
</script>
<style lang="less" scoped>
.operation-summary {
  margin-bottom: 10px;
  .header-box {
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
    height: 45px;
    line-height: 45px;
    background: rgb(247, 248, 250);
    padding-left: 15px;
  }
  .summaryData-content {
    display: flex;

    .summaryData-item {
      padding-left: 20px;
      margin-right: 20px;

      .numbers {
        color: #323233;
        font-family: 'PingFangSC-Medium';
      }
    }
  }
  .content-box {
    // display: flex;
    flex-direction: row;
    // justify-content: space-between;
    padding-right: 20px;
    flex-wrap: wrap;
    .content-perIt{
      height: 60px;
      padding-left: 20px;
      padding-top: 10px;
      position: relative;
      .content-item {
        display: flex;
        flex-direction: column;
        margin-right: 20px;
        min-width: 100px;
      }
      .verticalBar {
        border-right: 1px solid #DCDEE0;
        /* margin-right: 5px; */
        margin-top: 10px;
        position: absolute;
        top: 0;
        right: 0;
        height: calc(100% - 10px);
      }
      .sub-title {
        color: #969799;
        line-height: 20px;
        font-size: 14px;
      }
      .need-show-text {
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-end;
        .enlarge-content {
          font-size: 20px;
          font-weight: bold;
          color: #3D3D3D;
          font-family: 'PingFangSC-Medium';
        }

        .period {
          min-width: 106px;
        }
      }
      span {
        display: inline-block;
      }
    }
  }
}
</style>

